// Razorpay checkout helper - loads script on demand
let rzpLoaded = false;
let loadingPromise = null;

// Restrict Razorpay checkout to UPI only (no cards/netbanking/wallets).
export const UPI_ONLY_CONFIG = {
    display: {
        blocks: {
            upi: { name: 'Pay using UPI', instruments: [{ method: 'upi' }] },
        },
        sequence: ['block.upi'],
        preferences: { show_default_blocks: false },
    },
};

export function loadRazorpayScript() {
    if (rzpLoaded && window.Razorpay) return Promise.resolve(true);
    if (loadingPromise) return loadingPromise;
    loadingPromise = new Promise((resolve) => {
        const script = document.createElement('script');
        script.src = 'https://checkout.razorpay.com/v1/checkout.js';
        script.async = true;
        script.onload = () => { rzpLoaded = true; resolve(true); };
        script.onerror = () => resolve(false);
        document.body.appendChild(script);
    });
    return loadingPromise;
}

export function openRazorpayCheckout(options, onFailed) {
    if (!window.Razorpay) {
        throw new Error('Razorpay script not loaded');
    }
    const rzp = new window.Razorpay(options);
    if (onFailed) rzp.on('payment.failed', (resp) => onFailed(resp?.error || {}));
    rzp.open();
    return rzp;
}
